import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { Check } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { CtaButton } from "./CtaButton";

const POINTS = ["Doctor formulated, as stated by the maker", "Built around Mobilee® plus botanicals", "30 capsules per bottle", "Available from the official website"];

export const Featured = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [40, -40]);
  const rotate = useTransform(scrollYProgress, [0, 1], [-3, 3]);
  return (
    <section ref={ref} id="featured" className="relative bg-[#091D18] py-24 sm:py-32" data-testid="featured-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid grid-cols-1 items-center gap-10 overflow-hidden rounded-[2.5rem] bg-[#F2EDE4] p-6 sm:p-10 lg:grid-cols-12 lg:gap-6 lg:p-14">
          <Reveal className="lg:col-span-6">
            <div className="relative mx-auto max-w-[560px]">
              <div className="absolute inset-[8%] rounded-full bg-[#E5A93C]/25 blur-3xl" />
              <motion.img style={{ y, rotate }} src="/joint-genesis-doctor.webp" alt="Joint Genesis bottle by BioDynamix with doctor"
                data-testid="featured-product-image" className="relative w-full drop-shadow-[0_30px_40px_rgba(9,29,24,0.25)]" />
            </div>
          </Reveal>
          <div className="lg:col-span-6">
            <Reveal>
              <Eyebrow>Featured product</Eyebrow>
              <h2 className="mt-5 font-display text-4xl font-bold leading-[1.02] tracking-tight text-[#091D18] sm:text-5xl">
                Joint Genesis <span className="font-serif italic font-normal text-[#D96B43]">by BioDynamix.</span>
              </h2>
              <p className="mt-5 max-w-lg text-base leading-relaxed text-[#091D18]/75 sm:text-lg">
                “Move again, smile again” is the maker's promise. Here's what you get in every bottle, before you decide.
              </p>
            </Reveal>
            <ul className="mt-8 space-y-3">
              {POINTS.map((p, i) => (
                <Reveal key={p} delay={i * 0.08}>
                  <li className="flex items-center gap-3 text-[#091D18]" data-testid={`featured-point-${i}`}>
                    <span className="grid h-7 w-7 shrink-0 place-items-center rounded-full bg-[#0B3C35] text-[#F2EDE4]"><Check className="h-4 w-4" /></span>
                    {p}
                  </li>
                </Reveal>
              ))}
            </ul>
            <Reveal delay={0.3} className="mt-10">
              <CtaButton testId="featured-hoplink-button" placement="featured" className="hover:!bg-[#091D18] hover:!text-[#F2EDE4]">
                Get Joint Genesis
              </CtaButton>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};
